/**
 * CategoryFilter.tsx — 分类筛选胶囊
 */
import type { Category } from '../data/seed';
import { trackEvent } from '../lib/analytics';

interface CategoryFilterProps {
  categories: Category[];
  activeSlug?: string;
  onSelect: (slug: string | undefined) => void;
}

function chipClass(active: boolean): string {
  return active
    ? 'rounded-full bg-indigo-600 px-3.5 py-1.5 text-sm font-medium text-white shadow-sm'
    : 'rounded-full border border-slate-200 bg-white px-3.5 py-1.5 text-sm font-medium text-slate-600 transition hover:border-indigo-300 hover:text-indigo-600';
}

export default function CategoryFilter({ categories, activeSlug, onSelect }: CategoryFilterProps) {
  return (
    <div className="flex flex-wrap gap-2">
      <button
        type="button"
        onClick={() => onSelect(undefined)}
        className={chipClass(activeSlug === undefined)}
      >
        全部
      </button>
      {categories.map((category) => (
        <button
          key={category.slug}
          type="button"
          onClick={() => {
            trackEvent('filter_category', { category: category.slug });
            onSelect(category.slug);
          }}
          className={chipClass(activeSlug === category.slug)}
        >
          {category.name}
          <span className="ml-1 text-xs opacity-60">{category.count}</span>
        </button>
      ))}
    </div>
  );
}
